import { FillInputByNameInstruction } from '../FillInputByNameInstruction'

export class LastnameInstruction extends FillInputByNameInstruction {
  constructor ({ waitForNoLoaders, value }) {
    super({
      name: 'Lastname',
      inputName: 'lastname',
      waitForNoLoaders,
      value

    })
  }

  setDefaultValue (params) {
    this.value = params.userInformation.names.split(' ')[1]
  }
}
